import { getJson } from '../client'
import type { DateRange } from '../params'
import { API } from '../paths'
import { visitorsSchema, type Visitors } from '../schemas/visitors'

/** Входы посетителей за период (ТЗ п. 5.3, 5.5). period=custom с явными from/to, как у остальных периодных запросов. */
export const visitorsApi = {
  getVisitors: (params: DateRange): Promise<Visitors> =>
    getJson(API.visitors, visitorsSchema, { params: { period: 'custom', ...params } }),
}
